const GROUP_HEADER_INNER_HEIGHT = 40;
const GROUP_HEADER_VERTICAL_PADDING = 10;

/**
 * Used by board virtualization
 */
export const GROUP_HEADER_HEIGHT = GROUP_HEADER_INNER_HEIGHT + GROUP_HEADER_VERTICAL_PADDING * 2;
